import { Badge, Image, Table } from 'react-bootstrap';
import icUserGroup from '../../assets/img/ic-user-group.svg';
import icEyeClosed from '../../assets/img/ic-eye-closed.svg';
import {
    getCommunityDisplayName,
    getCommunitySubtitle,
    getCommunityPreviewText,
    formatConversationTimestamp,
    formatUnreadBadge,
} from '../../utils/conversations';

// Desktop Communities list — same table language as /discovery/countries
// (discovery-table + table-responsive.list). Mobile uses CommunityMobileList.
const CommunityDesktopTable = ({ conversations, currentUserId, onOpen }) => (
    <div className="table-responsive list">
        <Table className="discovery-table discovery-table--communities">
            <thead>
                <tr>
                    <th>Community</th>
                    <th>Type</th>
                    <th>Members</th>
                    <th>Last message</th>
                    <th>Last activity</th>
                </tr>
            </thead>
            <tbody>
                {conversations.map((conversation) => {
                    const subtitle = getCommunitySubtitle(conversation);
                    const unreadLabel = formatUnreadBadge(conversation.unreadCount);

                    return (
                        <tr
                            key={conversation._id}
                            className={`company-row discovery-row community-row${unreadLabel ? ' community-row--unread' : ''}`}
                            tabIndex={0}
                            onClick={() => onOpen(conversation)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') onOpen(conversation);
                            }}
                        >
                            <td>
                                <div className="community-row__name-cell">
                                    <span className="community-row__avatar" aria-hidden="true">
                                        <Image src={icUserGroup} alt="" />
                                    </span>
                                    <span className="community-row__name-block">
                                        <span className="community-row__name">{getCommunityDisplayName(conversation)}</span>
                                        {subtitle && <span className="community-row__subtitle">{subtitle}</span>}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <Badge bg="light" className="community-row__type-badge">
                                    {conversation.type === 'city' ? 'City' : 'Country'}
                                </Badge>
                                {conversation.isReadOnly && (
                                    <span className="community-row__readonly">
                                        <Image src={icEyeClosed} alt="" />
                                        Read-only
                                    </span>
                                )}
                            </td>
                            <td>{conversation.memberCount || 0}</td>
                            <td>
                                <div className="community-row__preview-cell">
                                    <span className="community-row__preview">{getCommunityPreviewText(conversation, currentUserId)}</span>
                                    {unreadLabel && (
                                        <Badge bg="primary" pill className="community-unread-badge">{unreadLabel}</Badge>
                                    )}
                                </div>
                            </td>
                            <td className="community-row__time">
                                {formatConversationTimestamp(conversation.lastMessageAt || conversation.createdAt)}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    </div>
);

export default CommunityDesktopTable;
